import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MemberAddForm } from "@/components/MemberAccounts";
import { ROLE_LABEL } from "@/lib/status";
import { usePractice } from "@/pages/StaffApp";

const CRED = /^(md|do|dmd|dds|np|pa|pa-c|rn|lcsw|lpc|lmft|lmhc|psyd|phd|aprn|fnp|pmhnp|dnp|ma|ms|msw)$/i;
const splitName = (full) => {
  const [head, ...rest] = full.replace(/^(dr\.?|doctor)\s+/i, "").split(",").map((s) => s.trim());
  const tail = rest.join(" ");
  if (tail && !tail.split(/[\s,]+/).every((w) => CRED.test(w.replace(/\./g, "")))) return { first_name: tail, last_name: head };
  const parts = head.split(/\s+/);
  return { first_name: parts.length > 1 ? parts.slice(0, -1).join(" ") : parts[0] || "", last_name: parts.length > 1 ? parts[parts.length - 1] : "" };
};

export default function ProviderAccountDialog({ provider, onClose, onAdded }) {
  const { practice, roles, role: myRole, role_labels: RL } = usePractice();
  const roleList = myRole === "regional_director" ? ["provider", "regional_director"] : roles;
  return (
    <Dialog open={!!provider} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-4xl" data-testid="provider-account-dialog">
        <DialogHeader><DialogTitle>Create staff account - {provider?.name}</DialogTitle>
          <DialogDescription>The account is linked to this provider record. Add the email and any other details, then create it.</DialogDescription></DialogHeader>
        {provider && <MemberAddForm key={provider.code} practice={practice} roleList={roleList} label={(r) => RL[r] || ROLE_LABEL[r] || r}
          preset={{ role: "provider", provider_code: provider.code, ...splitName(provider.name) }} onAdded={() => { onAdded(); onClose(); }} />}
      </DialogContent>
    </Dialog>
  );
}
